var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.651,
    height: 22.6,
    viewBox: "0 0 18.651 22.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-notifications-none",
    "data-name": "Icon material-notifications-none",
    d: "M15.026,25.75a2.263,2.263,0,0,0,2.256-2.256H12.769A2.263,2.263,0,0,0,15.026,25.75Zm6.769-6.769V13.34c0-3.464-1.839-6.363-5.077-7.13V5.442a1.692,1.692,0,1,0-3.385,0v.767c-3.227.767-5.077,3.655-5.077,7.13v5.641L6,21.237v1.128H24.051V21.237Zm-2.256,1.128H10.513V13.34c0-2.8,1.7-5.077,4.513-5.077s4.513,2.279,4.513,5.077Z",
    transform: "translate(-5.7 -3.45)",
    stroke: "#f3f3f3",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.581d6eff4c7f99cafcc25290dee68061.svg";
export { ForwardRef as ReactComponent };